import { render, staticRenderFns } from "./ControllerSimpleTable.vue?vue&type=template&id=1de03581"
import script from "./ControllerSimpleTable.vue?vue&type=script&lang=js"
export * from "./ControllerSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports